import App from "@/components/App";
import DisableDevtool from "disable-devtool";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./style/index.css";
import "./utils/i18n";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element not found");
}
DisableDevtool({
  md5: "f3ae2bfcf645f921637b9c0d789b0e47",
  disableMenu: true,
  url: "about:blank",
  timeOutUrl: "about:blank",
  clearLog: false,
  ignore: () => {
    const isDev = import.meta.env.DEV;
    return isDev;
  }
});
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
